<template>
  <section v-on:click="sectionClicked">
    <div class="notFound" v-if="!page || !page.page || !page.page.sectionData
      || page.page.sectionData.length < 1"></div>
    <template v-else>
      <section class="section" v-for="(sc, i) in page.page.sectionData" :key="`p${i}`"
        :class="{modalOpen: sc.modalOpen}">
        <Slider v-if="sc.type === 'Slider'" :section="sc"></Slider>
        <ImageHeader v-else-if="sc.type === 'Image Header'"
          :section="sc" :style="{'background-color': sc.color}"></ImageHeader>
        <LeftImage v-else-if="['Left Image', 'Right Image'].includes(sc.type)"
          :section="sc" :style="{'background-color': sc.color}"></LeftImage>
        <BlockArticles v-else-if="sc.type === 'Block Articles'"
          :section="sc" :page="page.page" :style="{'background-color': sc.color}"></BlockArticles>
        <IconSlider v-else-if="sc.type === 'Icon Slider'"
          :section="sc" :style="{'background-color': sc.color}"></IconSlider>
        <TextBlock v-else-if="sc.type === 'Text Block'"
          :section="sc" :style="{'background-color': sc.color}"></TextBlock>
        <Gallery v-else-if="sc.type === 'Gallery'"
          :section="sc" :style="{'background-color': sc.color}"></Gallery>
        <Subscription v-else-if="sc.type === 'Subscription'"
          :section="sc" :style="{'background-color': sc.color}"></Subscription>
        <CustomBlock v-else-if="sc.type === 'Custom Block'"
          :section="sc" :style="{'background-color': sc.color}"></CustomBlock>
        <Map v-else-if="sc.type === 'Map'"
          :section="sc" :style="{'background-color': sc.color}"></Map>
        <Form v-else-if="sc.type === 'Form'"
          :section="sc" :style="{'background-color': sc.color}"></Form>
        <TwoImage v-else-if="sc.type === 'Two Image'"
          :section="sc" :style="{'background-color': sc.color}"></TwoImage>
      </section>
    </template>
  </section>
</template>

<script>
import Slider from '@/components/Section/Slider.vue';
import LeftImage from '@/components/Section/LeftImage.vue';
import ImageHeader from '@/components/Section/ImageHeader.vue';
import BlockArticles from '@/components/Section/BlockArticles.vue';
import IconSlider from '@/components/Section/IconSlider.vue';
import Gallery from '@/components/Section/Gallery.vue';
import Subscription from '@/components/Section/Subscription.vue';
import Map from '@/components/Section/Map.vue';
import Form from '@/components/Section/Form.vue';
import TextBlock from '@/components/Section/TextBlock.vue';
import CustomBlock from '@/components/Section/CustomBlock.vue';
import TwoImage from '@/components/Section/TwoImage.vue';

export default {
  name: 'home',
  props: ['page', 'breadcrumb'],
  components: {
    Slider,
    LeftImage,
    ImageHeader,
    BlockArticles,
    IconSlider,
    Gallery,
    Subscription,
    Map,
    Form,
    TextBlock,
    CustomBlock,
    TwoImage,
  },
  data() {
    return {
      ch: null,
      loading: true,
    };
  },
  methods: {
    doNothing() {},
    sectionClicked() {},
  },
  mounted() {},
};
</script>

<style scoped lang="scss">
</style>
